import React from 'react';
import styles from './Map.module.scss'
import World from "../../../Assets/HomePage/world.png";
import LazyLoad from 'react-lazyload';
import boomer_boy from '../../../Assets/HomePage/boomer_map_boy.png'
import boomer_girl from '../../../Assets/HomePage/boomer_map_girl.png'

const Map = ({ mobile }) => {
    if (!mobile) {
        return (
            <LazyLoad height={100}>
                <div className={styles.mapContainer}>
                    <div className={styles.world}>
                        <img src={World} alt='img of the world'></img>
                    </div>
                    <h2>Escribli has a presence in over 100 countries!</h2>
                    <div className={styles.bgCropper}>
                        <img className={styles.boomer_boy} src={boomer_boy} alt="girl"/>
                        <img className={styles.boomer_girl} src={boomer_girl} alt="boomer"/>
                        <div className={styles.gradient}></div>
                    </div>
                </div>
            </LazyLoad>
        );
    } else {
        return (
            <LazyLoad height={100}>
                <div className={styles.mobileMapContainer}>
                    <div className={styles.mobileBg}>
                        <h2>Escribli has a presence in <br /><span>+ 150 </span><br />countries!</h2>
                    </div>
                </div>
            </LazyLoad>
        )
    }
}

export default Map;